var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCinnamon = function SvgCinnamon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cinnamon_svg__a)",
    d: "M233.372 110.663s3.1-2.251 4.667-3.571.963-5.041 0-6.361-2.814-6.234-7.346-6.721c-3.914-.42-46.784 11.991-61.9 14.642-20.753 3.641-74.7 18.683-84.817 20.123S31.637 140.3 30.031 140.3s-1.124 7.681 0 8.642a3.32 3.32 0 0 0 2.61 1.04C48.355 147.858 136 129.735 136 129.735l73.723-12.987z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cinnamon_svg__b)",
    d: "M236.776 126.945s4.021-3.564 4.182-5.67 0-9.4-3.056-10.529-2.062-.845-5.952 0c-7.91 1.717-40.256 8.464-48.1 9.233-7.54.74-79.142 13.223-88.313 15.066-9.33 1.874-35.175 7.829-45.685 9.719-9.009 1.62-15.12 4.536-17.856 4.536-2.735 0 .965 12.959 1.448 14.417s4.584 13.688 7.078 12.149 21.716-8.909 24.29-9.719 37.481-11.987 45.685-13.445 65.792-13.932 70.779-14.742 52.765-10.367 55.5-11.015"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cinnamon_svg__a",
    x1: 134.42,
    x2: 134.361,
    y1: 148.196,
    y2: 95.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1485B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#1988B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#2A90BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#459EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#6BB2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#9BCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#D6E9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cinnamon_svg__b",
    x1: 135.999,
    x2: 135.999,
    y1: 176,
    y2: 110.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1485B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#1988B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#2A90BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#459EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#6BB2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#9BCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#D6E9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgCinnamon;